import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { DEFAULT_FILE_NAME } from '@debbie/common/dist/constants.js';
import { TemplateType } from '@debbie/common/dist/templates/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import * as templatesAPI from '@debbie/cortex/dist/api/templates.js';
import { selectLetter } from '@debbie/cortex/dist/newInteractions/selectors.js';
import { Button, Modal } from '../index.js';
import { parseText } from '../../utils/templates.js';
import TemplateSearch from './TemplateSearch.js';
const AddFromTemplate = (props) => {
    const { case: singleCase, toggleAddTemplateModal, customer } = props;
    const letter = useSelector((s) => selectLetter(s, props.case.caseId));
    const lang = useSelector((s) => s.lang);
    const [isLoading, setIsLoading] = useState(false);
    const add = async () => {
        setIsLoading(true);
        const { pdfFileId } = await templatesAPI.genLetterPDF(letter.templateId, singleCase.caseId, {
            body: parseText(draftToHtml(convertToRaw(letter.editorState.getCurrentContent())), props.mentionSuggestions),
            caseId: singleCase.caseId,
        }, letter.templateFileName || DEFAULT_FILE_NAME);
        setIsLoading(false);
        toggleAddTemplateModal();
        c.newInteractions.addFiles(props.case.caseId, [
            {
                fileId: pdfFileId,
                contentType: 'application/pdf',
                fileName: letter.templateFileName || DEFAULT_FILE_NAME,
            },
        ]);
    };
    return (React.createElement(Modal, { header: lang.interactions.addTemplate, maxWidth: "500px", onToggle: toggleAddTemplateModal },
        React.createElement(TemplateSearch, { interaction: letter, templateType: TemplateType.LETTER, case: singleCase, customer: customer }),
        React.createElement(Button, { loading: isLoading, disabled: !letter.templateId, block: true, onClick: add }, lang.interactions.addTemplate)));
};
export default AddFromTemplate;
//# sourceMappingURL=AddFromTemplate.js.map